import AcquisitionChannel from "../../../model/acquisitionChannel/AcquisitionChannel";

/**
 * Fetch acquisition channels successful action.
 */
export const ACQUISITION_CHANNEL_FETCHED = "ACQUISITION_CHANNEL_FETCHED";
export type ACQUISITION_CHANNEL_FETCHED = { acquisitionChannels: Array<AcquisitionChannel> }

/**
 * Create acquisition channel successful action.
 */
export const ACQUISITION_CHANNEL_CREATED = "ACQUISITION_CHANNEL_CREATED";
export type ACQUISITION_CHANNEL_CREATED = { acquisitionChannel: AcquisitionChannel }

/**
 * Update acquisition channels successful action.
 */
export const ACQUISITION_CHANNEL_UPDATED = "ACQUISITION_CHANNEL_UPDATED";
export type ACQUISITION_CHANNEL_UPDATED = { acquisitionChannel: AcquisitionChannel }

/**
 *  Update acquisition channels sort order successful action.
 */
export const ACQUISITION_CHANNEL_SORT_ORDER_UPDATED = "ACQUISITION_CHANNEL_SORT_ORDER_UPDATED";
export type ACQUISITION_CHANNEL_SORT_ORDER_UPDATED = { acquisitionChannels: Array<AcquisitionChannel> }